import axios from 'axios';
import Cookies from 'js-cookie';

type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'delete';
type RequestData = Record<string, any>;
const BackendService = {
  request: async (method: HttpMethod, url: string, data?: RequestData) => {
    const token = Cookies.get('token');
    if (!token) {
      throw new Error('Authentication token not found');
    }
    return axios({
      method,
      url,
      data,
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    });
  },

  // Special method for FormData requests
  requestFormData: async (method: HttpMethod, url: string, data?: FormData) => {
    const token = Cookies.get('token');
    return axios({
      method,
      url,
      data,
      headers: {
        'x-auth-token': token,
        // Don't set Content-Type for FormData, let browser set it with boundary
      },
    });
  },

  Get: async (url: string) => BackendService.request('get', url),
  Post: async (url: string, data: RequestData) => BackendService.request('post', url, data),
  PostFormData: async (url: string, data: FormData) =>
    BackendService.requestFormData('post', url, data),
  Put: async (url: string, data: RequestData) => BackendService.request('put', url, data),
  Patch: async (url: string, data: RequestData) => BackendService.request('patch', url, data),
  PatchFormData: async (url: string, data: FormData) =>
    BackendService.requestFormData('patch', url, data),
  Delete: async (url: string) => BackendService.request('delete', url),
};

export default BackendService;
